jQuery(document).ready(function ($) {
    // AOS ANIMATION
    AOS.init({
      duration: 1000,    
      once: true,      
      easing: 'ease-in-out'
    });
    // loader-jquery
    $(document).ready(function () {
      setTimeout(function(){
          $("#preloader").addClass('remove');
      }, 1000);
    });
    // Initialize Lenis
    const lenis = new Lenis({
      duration: 1.2,        // scroll duration (seconds)
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), // smooth easing
      smooth: true,          // enable smooth scrolling
      smoothTouch: true,     // smooth scrolling on touch devices
      direction: 'vertical', // vertical scroll
      gestureOrientation: 'vertical',
      autoRaf: true, 
    });

    // Listen for the scroll event and log the event data
    lenis.on('scroll', (e) => {
      console.log(e);
    });
    //Quantity Plus Button
    $("#button-plus").on("click", function () {
      var qtyInput = $("#quantity-input");
      var currentVal = parseInt(qtyInput.val());
      var maxVal = parseInt(qtyInput.attr("max"));

      if (!isNaN(currentVal) && currentVal < maxVal) {
        qtyInput.val(currentVal + 1);
      }
    });
    //Quantity Minus Button
    $("#button-minus").on("click", function () {
      var qtyInput = $("#quantity-input");
      var currentVal = parseInt(qtyInput.val());
      var minVal = parseInt(qtyInput.attr("min"));

      if (!isNaN(currentVal) && currentVal > minVal) {
        qtyInput.val(currentVal - 1);
      }
    });

    // slider
    var swiper = new Swiper(".testi-slider", {
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
    var swiper1 = new Swiper(".mySwiper01", {
      loop: true,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: true,
      },
    });
    var swiper2 = new Swiper(".mySwiper02", {
        loop: true,
        slidesPerView: 3,
        spaceBetween: 10,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          1550: {
                slidesPerView: 3,
                spaceBetween: 22,
            },
            1400: {
                slidesPerView: 3,
                spaceBetween: 22,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 10,
            },
            320: { slidesPerView: 2, spaceBetween: 10 },
        }
    });
      swiper1.controller.control = swiper2;
      swiper2.controller.control = swiper1;
    });

// Cursor pointer
function mousemoveHandler(e) {
  try {
    const target = e.target;

    let tl = gsap.timeline({
      defaults: {
        x: e.clientX,
        y: e.clientY,
      }
    })
    let t2 = gsap.timeline({
      defaults: {
        x: e.clientX,
        y: e.clientY,
      }
    })


    // Main Cursor Moving 

    tl.to(".cursor1", {
      ease: "power2.out"
    })
      .to(".cursor2", {
        ease: "power2.out"
      }, "-=0.4")

  } catch (error) {
    console.log(error)
  }

}
document.addEventListener("mousemove", mousemoveHandler);

// RESPONSIVE MENU ENTRY JS
jQuery('.ham-menu-btn a').click(function(){
	jQuery('.responsive-menu').addClass('active');
    jQuery('body').addClass('stop-scroll');
});
// RESPONSIVE MENU EXIT JS
jQuery('.respon-cross a').click(function(){
	jQuery('.responsive-menu').removeClass('active');
    jQuery('body').removeClass('stop-scroll');
});
// RESPONSIVE MENU UL TOGGLE JS
jQuery(document).ready(function () {
    jQuery('.responsive-links ul li > a').click(function (e) {
        if (jQuery(this).siblings('ul').length > 0) {
            e.preventDefault();
            e.stopPropagation();
            
            jQuery('.responsive-links ul li > a').not(this).siblings('ul').slideUp();
            jQuery('.responsive-links ul li > a').not(this).parent().removeClass('active');

            jQuery(this).siblings('ul').slideToggle();
            jQuery(this).parent().toggleClass('active');
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".myProject");
  sliders.forEach(function (slider) {
    new Swiper(slider, {
      slidesPerView: 5,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: slider.querySelector(".swiper-button-next"),
        prevEl: slider.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        320: { slidesPerView: 1, spaceBetween: 10 },
        575: { slidesPerView: 2, spaceBetween: 15 },
        768: { slidesPerView: 2, spaceBetween: 15 },
        992: { slidesPerView: 3, spaceBetween: 20 },
      },
    });
  });
});

// === SEARCH POPUP JS ===
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openSearch");
  const closeBtn = document.getElementById("closeSearch");
  const overlay = document.getElementById("searchOverlay");

  if (openBtn && closeBtn && overlay) {
    // Open popup
    openBtn.addEventListener("click", () => {
      overlay.classList.add("active");
      document.body.style.overflow = "hidden"; // prevent scroll
      setTimeout(() => {
        overlay.querySelector(".search-input").focus();
      }, 200);
    });

    // Close popup
    closeBtn.addEventListener("click", () => {
      overlay.classList.remove("active");
      document.body.style.overflow = "";
    });

    // Close on overlay click
    overlay.addEventListener("click", (e) => {
      if (e.target === overlay) {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });

    // Close on ESC key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        overlay.classList.remove("active");
        document.body.style.overflow = "";
      }
    });
  }
});